import D from "@babel/runtime/helpers/esm/slicedToArray";
import m from "@semcore/utils/lib/capitalizeFirstLetter";
var $ = {
  top: "width",
  bottom: "width",
  left: "height",
  right: "height"
}, y = {
  width: "x",
  height: "y"
};
function c(i) {
  return !Object.keys(i).length;
}
function A(i) {
  var o, r = i.state;
  if (!(c(r.modifiersData.arrow) || c(r.modifiersData.popperOffsets))) {
    var v = r.placement.split("-"), s = D(v, 2), l = s[0], f = s[1], e = $[l], a = y[e], t = ((o = r.options.modifiers.find(function(g) {
      return g.name === "arrow";
    })) === null || o === void 0 ? void 0 : o.options.padding) || 0;
    if (f === "start") {
      var p = r.rects.reference[e];
      if (r.modifiersData.arrow[a] = t, p / 2 < t) {
        var w = r.elements.arrow["offset".concat(m(e))], h = w / 2 + t - p / 2 + 0.5;
        r.modifiersData.popperOffsets[a] -= h;
      }
    }
    if (f === "end") {
      var n = r.rects.reference[e], u = r.rects.popper[e], d = r.elements.arrow["offset".concat(m(e))];
      if (r.modifiersData.arrow[a] = u - d - t, n / 2 < t) {
        var O = d / 2 + t - n / 2;
        r.modifiersData.popperOffsets[a] += O;
      }
    }
  }
}
var b = {
  name: "arrowOffset",
  enabled: !0,
  phase: "main",
  fn: A,
  requires: ["arrow", "popperOffsets"],
  requiresIfExists: ["arrow"]
};
export {
  b as default
};
